<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    icon: string;
    iconColor?: string;
    iconSize?: number;
    backgroundColor?: string;
  }>(),
  {
    iconSize: 40,
    backgroundColor: "rgb(var(--v-theme-secondary))",
  }
);
</script>

<template>
  <div
    class="tw:absolute tw:left-1/2 tw:top-0 tw:z-modal-overlay-elevated tw:-translate-x-1/2 tw:-translate-y-1/2"
  >
    <div
      class="tw:flex tw:h-18 tw:w-18 tw:items-center tw:justify-center tw:rounded-full tw:shadow-lg"
      :style="{ backgroundColor: props.backgroundColor }"
    >
      <v-icon
        :icon="props.icon"
        :color="props.iconColor"
        :class="{ 'tw:text-on-primary': !props.iconColor }"
        :size="props.iconSize"
      />
    </div>
  </div>
</template>

<style scoped></style>
